import React from 'react';
import { Plus } from 'lucide-react';
import { SyncBadge, SyncState } from './SyncBadge';
interface TopBarProps {
  onNewLead: () => void;
  syncState: SyncState;
  syncText: string;
}
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/2u6MreNFCJLYjGpiWQ46Uw/ELITE_UTILS_(14).png';
export function TopBar({
  onNewLead,
  syncState,
  syncText
}: TopBarProps) {
  return <div className="sticky top-0 z-40 bg-cream/90 backdrop-blur-xl border-b border-line -mx-4 px-4 py-3" data-id="element-200">
      <div className="flex items-center justify-between gap-3 max-w-[1240px] mx-auto" data-id="element-201">
        <div className="flex items-center" data-id="element-202">
          <img src={LOGO_URL} alt="parquet72h" className="h-9 md:h-10 w-auto object-contain" data-id="element-203" />
        </div>
        <div className="flex items-center gap-3" data-id="element-204">
          <div className="hidden sm:block" data-id="element-205">
            <SyncBadge state={syncState} text={syncText} data-id="element-206" />
          </div>
          <button onClick={onNewLead} style={{
          backgroundColor: '#2B2B2B',
          color: '#ffffff'
        }} className="font-manrope font-extrabold rounded-xl px-4 py-[10px] text-[14px] flex items-center gap-1.5 hover:opacity-90 active:scale-[0.97] transition-all shadow-sm" data-id="element-207">
            <Plus className="w-4 h-4" strokeWidth={3} data-id="element-208" />
            Lead
          </button>
        </div>
      </div>
      <div className="sm:hidden mt-2 flex justify-end" data-id="element-209">
        <SyncBadge state={syncState} text={syncText} data-id="element-210" />
      </div>
    </div>;
}